import React from 'react';

const Error404Screen: React.FC = () => {
  return <>Not Found</>;
};

export default Error404Screen;
